<div *ngIf="_owners?.length > 0">
	<app-input
		type="text"
		label="Filter Owners"
		name="price"
		[startIcon]="ICON.SEARCH"
		(keyup)="applyFilter($event.target.value)"
		class="mb-2"
		[testHook]="testHooks.FilterOwners"
	></app-input>

	<span>Please select an owner to view their PIN</span>

	<div class="table-container mt-2">
		<table
			mat-table
			[dataSource]="dataSource"
			[trackBy]="trackByUid"
			matSort
			class="animate w-full dashboard-table border-l-2"
		>
			<ng-container matColumnDef="firstName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>First Name(s)</th>
				<td mat-cell *matCellDef="let element">
					{{ element.first_name | capitalize }}
				</td>
			</ng-container>

			<ng-container matColumnDef="lastName">
				<th mat-header-cell *matHeaderCellDef mat-sort-header>Last Name</th>
				<td mat-cell *matCellDef="let element">
					{{ element.last_name | capitalize }}
				</td>
			</ng-container>

			<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
			<tr
				mat-row
				*matRowDef="let row; columns: displayedColumns; let i = index"
				class="animate cursor-pointer"
				[class.bg-grey-lighter]="i == selectedIndex"
				(click)="selectName(row, i)"
			></tr>
		</table>
	</div>
</div>

<div *ngIf="_owners?.length === 0">
	Unable to find any matching property owners
</div>
